export default __webpack_public_path__ + "static/Plots0112-79a9bdbef9cd3e294bc85b390625f0bb.jpg";